import React from 'react';
import './Hero.css';
import ImageCarousel from './ImageCarousel';

const Hero = () => {
  const CONTACT_INFO = {
    phone: "5521966527607",
    message: "Olá! Tenho interesse nos serviços da Brilha Piscina. Gostaria de solicitar um orçamento."
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Piscina Verde? Bomba com Problema? <span className="highlight">Resolva Hoje mesmo.</span>
          </h1>
          <p className="hero-subtitle">
            Especialistas em instalação, manutenção e soluções técnicas para piscinas em Jacarepaguá, Barra e Recreio.
          </p>
          <p className="hero-description">
            Atendimento rápido, diagnóstico técnico e avaliação gratuita pelo WhatsApp.
          </p>
          <div className="hero-buttons">
            <a 
              href={`https://wa.me/${CONTACT_INFO.phone}?text=${encodeURIComponent(CONTACT_INFO.message)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Solicitar Orçamento
            </a>
            <a href="#services" className="btn-secondary">
              Nossos Serviços
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <h3>Inúmeros</h3>
              <p>Clientes Satisfeitos</p>
            </div>
            <div className="stat">
              <h3>5+</h3>
              <p>Anos de Experiência</p>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <ImageCarousel />
        </div>
      </div>
    </section>
  );
};

export default Hero;
